"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlOfflinePayloadSerialization = void 0;
class PaymentTerminalControlOfflinePayloadSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.timestamp = entity.timestamp
            ? entity.timestamp.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.timestamp = entity.timestamp
            ? new Date(entity.timestamp / 1000000)
            : undefined;
        return copy;
    }
}
exports.PaymentTerminalControlOfflinePayloadSerialization = PaymentTerminalControlOfflinePayloadSerialization;
